const GSM_BASIC =
  '@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞ\u001bÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?¡' +
  'ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà';
const GSM_EXTENDED = '\f^{}\\[~]|€';

export const MAX_SMS_SEGMENTS = 6;

const gsmUnitsFor = message => {
  return Array.from(message).reduce((units, character) => {
    if (units === null) return null;
    if (GSM_EXTENDED.includes(character)) {
      return units + 2;
    }
    return GSM_BASIC.includes(character) ? units + 1 : null;
  }, 0);
};

const unicodeUnitsFor = message =>
  Array.from(message).reduce(
    (units, character) => units + (character.codePointAt(0) > 0xffff ? 2 : 1),
    0
  );

export const analyzeSmsMessage = message => {
  const gsmUnits = gsmUnitsFor(message);
  const encoding = gsmUnits === null ? 'ucs2' : 'gsm7';
  const units = gsmUnits === null ? unicodeUnitsFor(message) : gsmUnits;
  const singleLimit = encoding === 'gsm7' ? 160 : 70;
  const multipartLimit = encoding === 'gsm7' ? 153 : 67;
  const segmentSize = units <= singleLimit ? singleLimit : multipartLimit;
  const segments = Math.max(1, Math.ceil(units / segmentSize));

  return {
    encoding,
    units,
    segments,
    segmentSize,
    remaining: segments * segmentSize - units,
    exceedsLimit: segments > MAX_SMS_SEGMENTS,
  };
};
